import { render, staticRenderFns } from "./cancelDeliveryDialog.vue?vue&type=template&id=19de6556&scoped=true"
import script from "./cancelDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./cancelDeliveryDialog.vue?vue&type=script&lang=js"
import style0 from "./cancelDeliveryDialog.vue?vue&type=style&index=0&id=19de6556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19de6556",
  null
  
)

export default component.exports